const VIDEO_EXTENSIONS: ReadonlyArray<string> = [
  '.mp4',
  '.mov',
  '.webm',
  '.ogg',
  '.m4v',
];

const IMAGE_EXTENSIONS: ReadonlyArray<string> = [
  '.jpg',
  '.jpeg',
  '.png',
  '.webp',
  '.gif',
  '.bmp',
  '.svg',
  '.heic',
  '.heif',
  '.avif',
  '.tiff',
  '.tif',
];

function normalizeValue(value: string | null | undefined): string | null {
  if (typeof value !== 'string') {
    return null;
  }
  const trimmed = value.trim().toLowerCase();
  return trimmed.length > 0 ? trimmed : null;
}

function stripQueryAndHash(value: string): string {
  const hashIndex = value.indexOf('#');
  const queryIndex = value.indexOf('?');
  const cutIndex = [hashIndex, queryIndex]
    .filter((index) => index >= 0)
    .sort((a, b) => a - b)[0];
  if (cutIndex === undefined) {
    return value;
  }
  return value.slice(0, cutIndex);
}

function getFileName(value: string): string {
  const clean = stripQueryAndHash(value);
  const slashIndex = clean.lastIndexOf('/');
  if (slashIndex < 0) {
    return clean;
  }
  return clean.slice(slashIndex + 1);
}

function hasExtension(value: string, extensions: ReadonlyArray<string>): boolean {
  const fileName = getFileName(value);
  return extensions.some((ext) => fileName.endsWith(ext));
}

export function isVideoByMimeType(value: string | null | undefined): boolean {
  const normalized = normalizeValue(value);
  if (!normalized) {
    return false;
  }
  return normalized.startsWith('video/');
}

export function isAudioByMimeType(value: string | null | undefined): boolean {
  const normalized = normalizeValue(value);
  if (!normalized) {
    return false;
  }
  if (normalized.startsWith('audio/')) {
    return true;
  }
  return normalized === 'application/ogg' || normalized === 'application/x-ogg';
}

export function isVideoByExtension(value: string | null | undefined): boolean {
  const normalized = normalizeValue(value);
  if (!normalized) {
    return false;
  }
  return hasExtension(normalized, VIDEO_EXTENSIONS);
}

export function isVideoByMimeOrExtension(
  mimeType: string | null | undefined,
  value: string | null | undefined
): boolean {
  if (isVideoByMimeType(mimeType)) {
    return true;
  }
  if (isAudioByMimeType(mimeType)) {
    return false;
  }
  return isVideoByExtension(value);
}

export function isImageByExtension(value: string | null | undefined): boolean {
  const normalized = normalizeValue(value);
  if (!normalized) {
    return false;
  }
  return hasExtension(normalized, IMAGE_EXTENSIONS);
}
